// extracted by mini-css-extract-plugin
export default {"_":"header____EMOiY","link":"header_link__hqOEB"};